export default {
  path: '/account',
  name: 'account',
  redirect: { name: 'account.details-page' },
  component: () => import(/* webpackChunkName: "user" */ '@/views/Home'),
  children: [
    {
      path: '/account/details',
      name: 'account.details-page',
      component: () =>
        import(
          /* webpackChunkName: "account-page" */ '@/views/Home/Account/DetailsPage'
        ),
    },
    {
      path: '/account/details/edit',
      name: 'account.edit-details-page',
      component: () =>
        import(
          /* webpackChunkName: "edit-profile-page" */ '@/views/Home/Account/EditDetailsPage'
        ),
    },
    {
      path: '/account/pricing/edit',
      name: 'account.edit-pricing-page',
      component: () =>
        import(
          /* webpackChunkName: "edit-pricing-page" */ '@/views/Home/Account/EditPricingPage'
        ),
    },
    {
      path: '/account/subscriptions',
      name: 'account.subscriptions-page',
      component: () =>
        import(
          /* webpackChunkName: "subscriptions-page" */ '@/views/Home/Account/SubscriptionsPage'
        ),
    },
    {
      path: '/account/subscription/:id/:username',
      name: 'account.subscription-details-page',
      component: () =>
        import(
          /* webpackChunkName: "subscription-details-page" */ '@/views/Home/Account/SubscriptionDetailsPage'
        ),
    },
    {
      path: '/account/transactions',
      name: 'account.transactions-page',
      component: () =>
        import(
          /* webpackChunkName: "transactions-page" */ '@/views/Home/Account/TransactionsPage'
        ),
    },
    {
      path: '/account/payouts',
      name: 'account.payouts-page',
      component: () =>
        import(
          /* webpackChunkName: "payouts-page" */ '@/views/Home/Account/PayoutsPage'
        ),
    },
    {
      path: '/account/payouts-bank',
      name: 'account.payouts-bank',
      component: () =>
        import(
          /* webpackChunkName: "payouts-bank" */ '@/views/Home/Account/PayoutsBank'
        ),
    },
  ],
}
